import { render, staticRenderFns } from "./d-discover-feed-entries-group.vue?vue&type=template&id=7c2a9381&scoped=true&"
import script from "./d-discover-feed-entries-group.vue?vue&type=script&lang=js&"
export * from "./d-discover-feed-entries-group.vue?vue&type=script&lang=js&"
import style0 from "./d-discover-feed-entries-group.vue?vue&type=style&index=0&id=7c2a9381&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2a9381",
  null
  
)

export default component.exports